const appInfo = {
    title: 'Blazer'
};
export default appInfo;

